<template>
  <v-wait :for="loaderId">
    <template slot="waiting">
      <b-row>
        <b-col cols="12" class="d-flex justify-content-center">
          <half-circle-spinner />
        </b-col>
      </b-row>
    </template>
    <template>
      <b-row class="mb-3">
        <b-col lg="12">
          <div
              class="font-weight-bold v3_color_teal border_bottom_1 border_bottom_light_teal pb-2 font_size_1000rem"
          >
            Demographics
          </div>
        </b-col>
      </b-row>
      <p v-if="icoStatistic">
        <span
          v-if="icoStatistic.physicians != null"
          class="d-inline-flex align-items-center font_size_1000rem"
        >
          <strong>{{ icoStatistic.physicians }}</strong>
          <span class="ml-1 separator">
            {{ isLandingDashboardPage ? 'Physicians With ICOs In Phairify' : 'Physicians In Your Subspecialty' }}
          </span>
        </span>
        <template v-if="!isLandingDashboardPage">
          <span
            v-if="icoStatistic.subspecialty"
            class="d-inline-flex align-items-center font_size_1000rem ml-3 small-mobile-screens"
          >
          <strong>{{ icoStatistic.subspecialty }}</strong>
          <span class="ml-1 separator">
            ICOs In Your Subspecialty
          </span>
        </span>
          <span
            v-if="icoStatistic.subspecialty_job_offers"
            class="d-inline-flex align-items-center font_size_1000rem ml-3 small-mobile-screens"
          >
          <strong>{{ icoStatistic.subspecialty_job_offers }}</strong>
          <span class="ml-1">
            Job Orders In Your Subspecialty
          </span>
        </span>
        </template>
      </p>
      <b-row>
        <b-col v-if="icoLocationStatistics" lg="6" md="12" sm="12">
          <usa-map-chart
            :chart-data="icoLocationStatistics"
            :chart-title="mapTitle"
          />
        </b-col>
        <b-col
          v-for="(res, index) in icoChartsResults"
          lg="6"
          md="6"
          sm="12"
          :key="res.id || index"
        >
          <div class="mx-auto h-100 shadow-none phairify-chart-card">
            <b-card-body class="p-0 h-100">
              <div v-if="res && (!res.results || !res.results.length)">
                <b-alert show variant="warning">
                  There are no ICOs for your specialty yet. Please check back
                  later.
                </b-alert>
              </div>
              <div v-else-if="res && res.insufficient">
                <b-alert show variant="warning">
                  There is not enough data to display
                </b-alert>
              </div>
              <div v-else-if="res" class="h-100">
                <chart-builder
                  :result="res"
                  format="job-question"
                  :comparison="{}"
                  :is-stats-visible="false"
                  class="h-100"
                />
              </div>
            </b-card-body>
          </div>
        </b-col>
      </b-row>
    </template>
  </v-wait>
</template>

<script>
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import Api from '@/providers/Api';
import { HalfCircleSpinner } from 'epic-spinners';
import UsaMapChart from '@/components/dashboard/metrics/components/UsaMapChartV3';
import ChartBuilder from '@/components/survey/results/ChartBuilder';

export default {
  name: 'ConnectDemographic',
  components: {
    UsaMapChart,
    HalfCircleSpinner,
    ChartBuilder,
  },
  props: {
    isLandingDashboardPage: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      icoStatistic: null,
      icoLocationStatistics: null,
      icoChartsResults: [],
    };
  },
  created: function () {
    this.getMetricsData();
  },
  computed: {
    loaderId: function () {
      return `loading_${this.$options.name}`;
    },
    mapTitle: function () {
      return `Where your colleagues are looking for new opportunities`;
    },
    isDemoMode: function () {
      return this.$store.getters.isDemoMode;
    },
    user: function () {
      return this.$store.state.user ? this.$store.state.user : {};
    },
    isDemoUser: function () {
      return !!this.user.is_demo;
    },
  },
  methods: {
    getMetricsData: async function () {
      this.$wait.start(this.loaderId);
      try {
        let getStatisticFunctions = [];
        if (this.isLandingDashboardPage) {
          getStatisticFunctions = [
            Api.getIcoStatisticsLandingDashboard(),
            Api.getIcoLocationStatisticsLandingDashboard(),
            Api.getIcoValuesForDashboardChartsLandingDashboard(),
          ];
        } else if (this.isDemoMode) {
          getStatisticFunctions = [
            Api.getMockIcoStatistics(),
            Api.getMockIcoLocationStatistics(),
            Api.getMockIcoValuesForDashboardCharts(),
          ];
        }
        else {
          getStatisticFunctions = [
            Api.getIcoStatistics(),
            Api.getIcoLocationStatistics(),
            Api.getIcoValuesForDashboardCharts(),
          ];
        }
        const fetchResults = await Promise.allSettled(getStatisticFunctions);
        if (fetchResults[0] && fetchResults[0].status === 'fulfilled')
          this.icoStatistic = fetchResults[0].value;
        else
          this.$toasted.error('Unable to upload ICO statistics.', {
            duration: 3000,
          });
        if (fetchResults[1] && fetchResults[1].status === 'fulfilled')
          this.icoLocationStatistics = fetchResults[1].value; 
        else
          this.$toasted.error('Unable to upload Desired Location data.', {
            duration: 3000,
          });
        if (fetchResults[2] && fetchResults[2].status === 'fulfilled')
          this.icoChartsResults = fetchResults[2].value;
        else
          this.$toasted.error('Unable to upload ico charts.', {
            duration: 3000,
          });
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.$wait.end(this.loaderId);
      }
    },
  },
};
</script>

<style scoped>
.separator {
  border-right: 1px solid #00586f;
  padding-right: 10px;
}
</style>
